import * as BABYLON from '@babylonjs/core';

import '@babylonjs/loaders/glTF/';

import BabylonObject from "./objects/BabylonObject.js";
import BabylonHotspot from "./objects/BabylonHotspot.js";
import Fire from "./objects/Fire.js";
import Explosion from "./objects/Explosion.js";
import Label from "./objects/Label.js";
import babylonDefaultConfig from "./babylonDefaultConfig.js";
import EventBus from "../tools/event-bus";
import mergeConfig from "../tools/mergeConfig";

// https://doc.babylonjs.com/extensions/configuring_the_viewer
// https://doc.babylonjs.com/extensions/the_templating_system
let BabylonController = {
    constructor()
    {
        this.ready = false;
    },
    init(config)
    {
        // Babylon Config und Standardwerte zusammenführen
        this.config = mergeConfig(babylonDefaultConfig, config.babylon);

        // Objekte die geladen werden
        this.configObjects = config.objects;

        let self = this;
        this.objects = {};
        this.cameraMoveAnimation = false;

        /// Global Variables
        this.lightIntensity = this.config.lightIntensity;
        let backgroundRed = this.config.backgroundRed;
        let backgroundGreen = this.config.backgroundGreen;
        let backgroundBlue = this.config.backgroundBlue;
        this.minCamRadius = this.config.minCamRadius;
        this.maxCamRadius = this.config.maxCamRadius;
        this.panSensibility = this.config.panSensibility;
        this.animationLength = this.config.functionDefaults.setAnimationSpeed[0];

        // Babylon Lade Seite überschreiben mit leerer Funktion (wir zeigen dafür die vue.js Ansicht)
        BABYLON.DefaultLoadingScreen.prototype.displayLoadingUI = function ()
        {
        };

        // Lade Seite schließen => Babylon Ready
        BABYLON.DefaultLoadingScreen.prototype.hideLoadingUI = function ()
        {
            self.ready = true;
            EventBus.$emit('BABYLON.Loaded');
        };

        // Babylon Debug Funktionen laden
        if (process.env.NODE_ENV === 'development')
        {
            import("@babylonjs/core/Debug/debugLayer");
            import("@babylonjs/inspector");
        }

        // Get the 3D canvas element
        let canvas = document.getElementById("renderCanvas");
        this.canvas = canvas;

        // Generate the BABYLON 3D engine
        let engine = new BABYLON.Engine(canvas, true);
        this.engine = engine;

        /******* Add the create scene function ******/
        let createScene = function ()
        {

            // Create the scene space

            // TODO TBD
            // engine.displayLoadingUI();

            let scene = new BABYLON.Scene(engine);
            self.scene = scene;

            // Debug
            //scene.debugLayer.show();

            // self.createLoadingScreenV2(scene);

            // Hintergrund: Blau Grau
            scene.clearColor = new BABYLON.Color3(backgroundRed, backgroundGreen, backgroundBlue);

            self.addCameraAndLight(scene);

            self.loadObjects();


            BABYLON.SceneLoader.Append("./3d-models/", "Box.glb", scene, function (scene)
            {
                // Erstmal alles ausblenden
                for (let i = 0; i < scene.meshes.length; i++)
                {
                    if (scene.meshes[i].name === '__root__')
                    {
                        scene.meshes[i].setEnabled(false);
                    }
                }
            });

            return scene;
        };


        /******* End of the create scene function ******/

        let scene = createScene(); //Call the createScene function

        // /// Scene optimizer
        // let options = new BABYLON.SceneOptimizerOptions(30, 2000);
        // options.addOptimization(new BABYLON.HardwareScalingOptimization(0, 1));
        // options.addOptimization(new BABYLON.HardwareScalingOptimization(0, 1.5));
        // options.addOptimization(new BABYLON.HardwareScalingOptimization(scene, options));
        // // Optimizer
        // new BABYLON.SceneOptimizer(scene, options);

        // BABYLON.SceneOptimizerOptions.HighDegradationAllowed();

        // Register a render loop to repeatedly render the scene
        engine.runRenderLoop(function ()
        {
            scene.render();
        });

        // Watch for browser/canvas resize events
        window.addEventListener("resize", function ()
        {
            engine.resize();
        });

    },

    showDebug()
    {
        this.scene.debugLayer.show();
    },

    createDebugger()
    {
        if (process.env.NODE_ENV === 'development')
        {
            let sceneInstrumentation = new BABYLON.SceneInstrumentation(this.scene);
            sceneInstrumentation.captureRenderTime = true;
            this.scene.actionManager = new BABYLON.ActionManager(this.scene);
            this.scene.actionManager.registerAction(new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnKeyUpTrigger, (evt) =>
            {
                if (evt.sourceEvent.key === "u")
                {
                    if ( document.getElementById('app').style.display === 'none' )
                    {
                        document.getElementById('app').style.display = 'flex';
                        window.babylonController.hotspot.sprite.isVisible = true;
                    }
                    else
                    {
                        document.getElementById('app').style.display = 'none';
                        window.babylonController.hotspot.sprite.isVisible = false;
                    }
                }

                if (evt.sourceEvent.key === "i")
                {

                    sceneInstrumentation.captureDrawCalls = true;

                    /* eslint-disable no-console */
                    console.log("All known Animations in the scene: ");
                    console.log(this.scene.animationGroups);
                    console.log("Current Camera Settings: ");
                    console.log("Alpha: " + this.scene.activeCamera.alpha
                        + "  // Beta: " + this.scene.activeCamera.beta
                        + "  // Radius: " + this.scene.activeCamera.radius
                    );
                    console.log("Cam Target: " + this.scene.activeCamera.target);
                    console.log("Draw Calls: " + sceneInstrumentation.drawCallsCounter.current);
                    console.log("" + sceneInstrumentation.renderTimeCounter.current
                        + "ms // 16ms are 60fps. Anything higher is evil!");
                    console.log("Theoretical FPS: " + 1 / (sceneInstrumentation.renderTimeCounter.current * 0.001));
                    /* eslint-enable no-console */

                    sceneInstrumentation.captureDrawCalls = false; // Turn Off for performance
                }
            }));
        }
    },

    addCameraAndLight(scene)
    {
        // Kamera
        let camera = new BABYLON.ArcRotateCamera("Camera", Math.PI / 2, Math.PI / 2, 100, new BABYLON.Vector3(0, 3, 0), scene);
        camera.attachControl(this.canvas, true, false, false); // Kamera Steuerung
        camera.panningSensibility = this.panSensibility; // Kamera kann nicht verschoben werden
        // Zoom Limits
        camera.lowerRadiusLimit = this.minCamRadius;
        camera.upperRadiusLimit = this.maxCamRadius;
        camera.upperBetaLimit = Math.PI / 2;

        this.camera = camera;

/*
        // Add lights to the scene   Christian: Licht fürs Titelbild 
        let hemisphericLight = new BABYLON.HemisphericLight("HemisphericLight", new BABYLON.Vector3(1, 1, 0), scene);  //1,1,0 //gut: 30,10,20
        hemisphericLight.intensity = this.lightIntensity;
*/

        // Add lights to the scene
        let hemisphericLight = new BABYLON.HemisphericLight("HemisphericLight", new BABYLON.Vector3(30, 50, 20), scene);  //1,1,0 //gut: 30,10,20
        hemisphericLight.intensity = this.lightIntensity;


        let hemisphericLight2 = new BABYLON.HemisphericLight("HemisphericLight", new BABYLON.Vector3(-10, 10, -30), scene);  //1,1,0 //gut: -6, 10,-20
        hemisphericLight2.intensity = 0.5;

        // CANCEL CAMERA MOVE ANIMATION
        scene.onPointerDown = () =>
        {
            if (this.cameraMoveAnimation)
            {
                this.cameraMoveAnimation.stop();
                // Force Stop Henrik
                this.scene.stopAnimation(this.scene.activeCamera);
            }
            this.cameraMoveAnimation = false;
        };

    },

    onReady(fct)
    {
        if (this.ready)
        {
            fct();
        }
        else
        {
            EventBus.$on('BABYLON.Loaded', fct);
        }
    },

    addObject(obj)
    {
        this.objects[obj.name] = obj;
        this[obj.name] = obj;
    },

    loadObjects()
    {
        // --------------------------------------------------------------------------------
        //  Template Objekte laden
        // --------------------------------------------------------------------------------
        let objects = this.configObjects;
        for (let key in objects)
        {
            if (objects.hasOwnProperty(key))
            {
                let babylonObject = new BabylonObject(
                    this.scene,
                    objects[key].filename,
                    objects[key].name,
                    objects[key].options
                );
                if (typeof objects[key].callback === "function")
                {
                    babylonObject.callback = objects[key].callback;
                }
                this.addObject(babylonObject);
            }
        }

        // --------------------------------------------------------------------------------
        //	Hotspot
        // --------------------------------------------------------------------------------
        this.addObject(new BabylonHotspot(
            this.scene,
            'hotspot',
            {
                trigger: true,
                visible: false,
                scale: 1,
                //material: this.scene.getMaterialByID('hotspotStandardMaterial'),
                position: [0, 6, -2],
            }
        ));

        // --------------------------------------------------------------------------------
        //	Label / Text
        // --------------------------------------------------------------------------------
        this.addObject(new Label(
            this.scene,
            "label",
            {
                visible: false,
                text: 'Notre Dame',
                position: [0, 9, 0],
            }
        ));

        // --------------------------------------------------------------------------------
        //	Fire
        // Achtung: Wenn das Feuer vor den 3D Objekten gestartet wird,
        // werden beim Reload die Object.child nicht angezeigt (z.B. bei notreDame).
        // --------------------------------------------------------------------------------
        this.addObject(new Fire(
            this.scene,
            'fire',
            {
                visible: false,
            }
        ));


        // --------------------------------------------------------------------------------
        //	Explosion
        // Achtung: Wenn das Feuer vor den 3D Objekten gestartet wird,
        // werden beim Reload die Object.child nicht angezeigt (z.B. bei notreDame).
        // --------------------------------------------------------------------------------
        this.addObject(new Explosion(
            this.scene,
            'explosion',
            {
                visible: false,
            }
        ));

    },

    // --------------------------------------------------------------------------------
    //  Animation
    // --------------------------------------------------------------------------------

    startAnimation(animation, loop, speedratio)
    {
        this.scene.getAnimationGroupByName(animation).start(loop, speedratio);
    },

    goToAnimation(animation, frame){
        var aGroup = this.scene.getAnimationGroupByName(animation);
        aGroup.start();
        aGroup.goToFrame(frame);
        aGroup.pause();
    },

    // --------------------------------------------------------------------------------
    //  Camera
    // --------------------------------------------------------------------------------
    setCamera(alpha, beta, radius)
    {
        this.scene.activeCamera.alpha = alpha;
        this.scene.activeCamera.beta = beta;
        this.scene.activeCamera.radius = radius;
    },

    setFOV(radians)
    {
        this.scene.activeCamera.fov = radians;
    },

    moveCamera(alpha, beta, radius, newX, newY, newZ)
    {
        let scene = this.scene;
        let self = this;

        let positionIsIdentical = false;

        // Standard Target aus der Config laden
        if (typeof newX === 'undefined')
        {
            newX = this.config.functionDefaults.moveCamera[3];
            newY = this.config.functionDefaults.moveCamera[4];
            newZ = this.config.functionDefaults.moveCamera[5];
        }

        let targetVector = new BABYLON.Vector3(newX, newY, newZ);

        // ------------------------------------------------
        var rotateFunc = function (alphaPresent)
        {
            var toAlpha = null;
            //alpha
            var alphaLast = scene.activeCamera.alpha; //camera.alpha;
            var alphaDelta = alphaLast % (2 * Math.PI);//[0,2Pi]
            var alphaLarge = alphaLast - alphaDelta;
            // var angle=alphaDelta-alphaPresent;
            var absAlphaAngle = Math.abs(alphaDelta - alphaPresent);
            if (absAlphaAngle > Math.PI)
            {// 0 to 2Pi or 2Pi to 0
                if (alphaDelta >= alphaPresent)
                {//clockwise
                    toAlpha = alphaPresent + alphaLarge + 2 * Math.PI;
                }
                else
                {
                    toAlpha = alphaPresent + alphaLarge - 2 * Math.PI;
                }
            }
            else
            {
                toAlpha = alphaPresent + alphaLarge;
            }
            return toAlpha;
        };
        // ------------------------------------------------
        if (scene.activeCamera.alpha === rotateFunc(alpha) && scene.activeCamera.beta === beta && scene.activeCamera.radius === radius && this.scene.activeCamera.target === targetVector)
        {
            positionIsIdentical = true;
        }

        if (!positionIsIdentical)
        {
            this.camera.detachControl(this.canvas);


            let targetAnim = new BABYLON.Animation("targetAnim", "target", 30,
                BABYLON.Animation.ANIMATIONTYPE_VECTOR3, BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE); //ANIMATIONLOOPMODE_CONSTANT);
            let targetKeys = [{frame: 0, value: scene.activeCamera.target}, {
                frame: this.animationLength,
                value: targetVector
            }];
            targetAnim.setKeys(targetKeys);

            let easingFunction = new BABYLON.CubicEase();
            easingFunction.setEasingMode(BABYLON.EasingFunction.EASINGMODE_EASEINOUT);
            targetAnim.setEasingFunction(easingFunction);
            scene.activeCamera.animations.push(targetAnim);


            // Doku https://doc.babylonjs.com/babylon101/animations
            let alphaAnim = new BABYLON.Animation("alphaAnim", "alpha", 30,
                BABYLON.Animation.ANIMATIONTYPE_FLOAT, BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE); //ANIMATIONLOOPMODE_CONSTANT);
            let betaAnim = new BABYLON.Animation("betaAnim", "beta", 30,
                BABYLON.Animation.ANIMATIONTYPE_FLOAT, BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE); //ANIMATIONLOOPMODE_CONSTANT);
            let radiusAnim = new BABYLON.Animation("radiusAnim", "radius", 30,
                BABYLON.Animation.ANIMATIONTYPE_FLOAT, BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE); //ANIMATIONLOOPMODE_CONSTANT);

            let alphaKeys = [{frame: 0, value: scene.activeCamera.alpha}, {
                frame: this.animationLength,
                value: rotateFunc(alpha)
            }];
            let betaKeys = [{frame: 0, value: scene.activeCamera.beta}, {frame: this.animationLength, value: beta}];
            let radiusKeys = [{frame: 0, value: scene.activeCamera.radius}, {
                frame: this.animationLength,
                value: radius
            }];

            alphaAnim.setKeys(alphaKeys);
            betaAnim.setKeys(betaKeys);
            radiusAnim.setKeys(radiusKeys);

            // Beschleunigen und Abbremsen
            //let easingFunction = new BABYLON.CubicEase();
            easingFunction.setEasingMode(BABYLON.EasingFunction.EASINGMODE_EASEINOUT);
            alphaAnim.setEasingFunction(easingFunction);
            betaAnim.setEasingFunction(easingFunction);
            radiusAnim.setEasingFunction(easingFunction);

            scene.activeCamera.animations.push(alphaAnim);
            scene.activeCamera.animations.push(betaAnim);
            scene.activeCamera.animations.push(radiusAnim);
            this.cameraMoveAnimation = scene.beginAnimation(scene.activeCamera, 0, this.animationLength, false, 3, function ()
            {

                self.camera.attachControl(self.canvas, true, false, false);
                // nav.style.opacity = 1;

            });
        }
    },

    setState(newState)
    {
        // Objekte ansteuern
        for (let obj in this.objects)
        {
            if (this.objects.hasOwnProperty(obj))
            {
                this.objects[obj].setState(newState[obj]);
            }
        }

        // Befehle vom Controller verfügbar machen
        let commands = this.config.functionDefaults;
        for (let command in commands)
        {
            if (commands.hasOwnProperty(command))
            {
                // Befehl aufrufen
                if (newState.hasOwnProperty(command))
                {
                    // mit Parametern aus newState
                    this[command](...newState[command]);
                }
                else
                {
                    // mit dem Standartwert aus der Config
                    this[command](...commands[command]);
                }
            }
        }

        // Fehlende Babylon Objekte bei der Entwicklung ausgeben
        if (process.env.NODE_ENV === 'development')
        {
            let commands = Object.keys(this.config.functionDefaults);
            for (let obj in newState)
            {
                if (newState.hasOwnProperty(obj))
                {
                    // wenn kein Befehl und kein Objekt
                    if (commands.indexOf(obj) === -1 && !this.objects.hasOwnProperty(obj))
                    {
                        // eslint-disable-next-line no-console
                        console.error('Missing Babylon Object:', obj);
                    }
                }
            }
        }
    },

    setTarget(newX, newY, newZ)
    {
        this.scene.activeCamera.target = new BABYLON.Vector3(newX, newY, newZ);
    },

    setCameraRadiusLimit(min, max)
    {
        this.scene.activeCamera.lowerRadiusLimit = min;
        this.scene.activeCamera.upperRadiusLimit = max;

    },

    setClipping(min, max){
        this.scene.activeCamera.minZ = min;
        this.scene.activeCamera.maxZ = max;
    },

    zoomCamera(radians)
    {
        let scene = this.scene;
        let self = this;
        let zoomAnim = new BABYLON.Animation("zoomAnim", "fov", 30, BABYLON.Animation.ANIMATIONTYPE_FLOAT, BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE);

        let zoomKeys = [{frame: 0, value: scene.activeCamera.fov}, {frame: this.animationLength, value: radians}];
        zoomAnim.setKeys(zoomKeys);

        let easingFunction = new BABYLON.CubicEase();
        easingFunction.setEasingMode(BABYLON.EasingFunction.EASINGMODE_EASEINOUT);
        zoomAnim.setEasingFunction(easingFunction);
        scene.activeCamera.animations.push(zoomAnim);
        this.scene.beginAnimation(scene.activeCamera, 0, this.animationLength, false, 3, function ()
        {
            self.camera.attachControl(self.canvas, true, false, false);
        });
    },

    setAnimationSpeed(value)
    {
        this.animationLength = value;
    },

    setNewMaterial(meshName)
    {
        let material = new BABYLON.StandardMaterial("myMaterial", this.scene);
        material.diffuseColor = new BABYLON.Color3(1, 0, 1);

        for (let i = 0; i < this.scene.meshes.length; i++)
        {
            if (this.scene.meshes[i].name === meshName)
            {
                //console.log("Found it.");
                this.scene.meshes[i].material = material;
            }
        }
    },

    findMesh(meshName)
    {
        for (let i = 0; i < this.scene.meshes.length; i++)
        {
            if (this.scene.meshes[i].name === meshName)
            {
                return this.scene.meshes[i];
            }
        }
    },

    setTexture(meshName)
    {
        let mesh = this.findMesh(meshName);
        let newMaterial = new BABYLON.PBRMetallicRoughnessMaterial(meshName + "_pbr", this.scene);
        newMaterial.baseColor = new BABYLON.Texture("./texture/HotspotSprite.png", this.scene);
        mesh.material = newMaterial;
    },

    setAutoRotateBehaviour(bool){
        this.scene.activeCamera.useAutoRotationBehavior = bool;
    },

    // createLoadingScreenV2(scene)
    // {
    //     //creates loading elements
    //     let loadingBG = new BABYLON.GUI.Rectangle();
    //     loadingBG.width = 1920;
    //     loadingBG.height = 1080;
    //     loadingBG.color = new BABYLON.Color3(this.backgroundRed, this.backgroundGreen, this.backgroundBlue);
    //     loadingBG.background = this.config.backgroundHex;
    //     let loadingSquare = new BABYLON.GUI.Image("image", "img/800px-ZDF_logo.svg.png");
    //     loadingSquare.width = "200px";
    //     loadingSquare.height = "120px";
    //     loadingSquare.top = "0%";
    //     let loadingCircle = new BABYLON.GUI.Image("circle", "img/circleSmall.png");
    //     loadingCircle.width = "512px";
    //     loadingCircle.height = "512px";
    //     loadingCircle.top = "0%";
    //     let fullscreenGUI = BABYLON.GUI.AdvancedDynamicTexture.CreateFullscreenUI("FullscreenUI", true);
    //     fullscreenGUI.idealWidth = 1920;
    //     fullscreenGUI.idealHeight = 1080;
    //     fullscreenGUI.addControl(loadingBG); //Show loading screen
    //     fullscreenGUI.addControl(loadingSquare);
    //     fullscreenGUI.addControl(loadingCircle);
    //     scene.registerBeforeRender(function() { //Spin the square
    //         let deltaTime = scene.getEngine().getDeltaTime();
    //         loadingCircle.rotation += 0.001 * deltaTime;
    //     });
    //     //closes loading window after completion
    //     scene.executeWhenReady(function() { //When everything is done loading
    //         fullscreenGUI.removeControl(loadingBG);
    //         fullscreenGUI.removeControl(loadingSquare);
    //         fullscreenGUI.removeControl(loadingCircle);
    //     });
    // }

};

export default BabylonController